
import MatchDetailsModel from '../components/widgets/match-details/prematch/model-match-details-prematch';
import OutrightModel from '../components/widgets/category-outrights/model-outright';
import OutrightOutcomeModel from '../components/widgets/category-outrights/model-outright-outcome';
import TournamentTabModel from '../components/widgets/category-outrights/model-tournament-tab';

/**
 * Model for Category/Tournaments
 */
export default class TournamentModel {
  /**
   * class constructor method
   * @param data
   * @param sportId
   */
  constructor(data, sportId, is3way) {
    /**
     * Sport ID
     * @type {number}
     */
    this.sportId = sportId;
    /**
     * Flag whether main market is 3 Way
     * @type {boolean}
     */
    this.is3way = is3way;
    /**
     * Category ID
     * @type {number}
     */
    this.categoryId = data.cid;
    /**
     * Tournament ID, it can be zero also for category outrights
     * @type {number}
     */
    this.id = data.id;
    /**
     * Category Name
     * @type {string}
     */
    this.categoryName = data.nc;
    /**
     * Tournament Name
     * @type {string}
     */
    this.tournamentName = data.nt;
    /**
     * Matches array
     * @type {array}
     */
    this.matches = data.m ? this.mapMatches(data.m) : [];
    /**
    * @type {OutrightModel[]}
    */
    const outrights = data.o ? this.mapOutrights(data.o) : [];
    /**
    * @type {TournamentTabModel[]}
    */
    this.tournamentTabs = data.tt ? data.tt.map(t => new TournamentTabModel(t)) : [];
    /**
    * @type {OutrightModel[]}
    */
    this.outrights = outrights;
    /**
    * @type {OutrightModel[]}
    */
    this.multiOutrights = outrights.filter(o => o.outcomes.length > 1);
    /**
     * @type {OutrightModel[]}
     */
    this.directOutrights = outrights.filter(o => o.outcomes.length === 1);
    /**
     * is group
     * @type {boolean}
     */
    this.isGroup = data.gItem;
    /**
     * is tournament US
     * @type {boolean}
     */
    this.isUS = data.tus;
  }

  /**
   * Method for mapping inner objects from API with parent model
   * @param matchList list of tournament matches
   * @return mapped matches in proper match model
   */
  mapMatches(matchList) {
    let matches = [];
    matchList.forEach((m) => {
      // map tournament and category name for each match
      m.cn = this.categoryName;
      m.tn = this.tournamentName;
      let match = new MatchDetailsModel(m, false, APP_SETTINGS.formatting.shortDateFormat, APP_SETTINGS.formatting.shortTimeFormat);
      matches.push(match);
    });
    return matches;
  }

  /**
   * Method for mapping inner objects from API with parent model
   * @param outrightList list of tournament outrights
   * @return mapped outrights in proper outright model
   */
  mapOutrights(outrightList) {
    let outrights = [];
    outrightList.forEach((o) => {
      let outright = new OutrightModel(o);
      outright.sportId = this.sportId;
      outright.tournamentName = this.tournamentName;
      outright.categoryName = this.categoryName;
      outright.outcomes = o.o.map(ort => new OutrightOutcomeModel(ort));
      outrights.push(outright);
    });
    return outrights;
  }
}
